export class Errored {
	static readonly type = '[llc] errored';
	constructor(public logData: unknown) {}
}

export class Loaded {
	static readonly type = '[llc] loaded';
	constructor(public connectedIds: string[]) {}
}

export class Loading {
	static readonly type = '[llc] loading';
}

export class Revoke {
	static readonly type = '[llc] revoke';
	constructor(public userId: string) {}
}
